import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import { requestFailCallback } from '../../utils/serviceUtil.js';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import 'tslib';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import { responseSuccessCallbackV3, requestSuccessCallbackV3 } from '../../utils/serviceUtilv3.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import { getActiveOrgId, ACTIVE_ORG_REJECTION_CODES, notifyActiveOrgRejected } from '../../utils/activeOrganization.js';
import axios from 'axios';

const baseDiscoverService = axios.create({
    baseURL: process.env.PEEK_APP_DISCOVER_API_URL,
});
baseDiscoverService.defaults.headers.common["Content-Type"] = "application/json";
baseDiscoverService.defaults.headers.common["x-peek-api-version"] = process.env.PEEK_APP_API_VERSION;
// Wrap requestSuccessCallbackV3 to inject X-Peek-Organization header
const requestSuccessCallbackDiscover = (config) => {
    // Call the base callback first
    const baseConfig = requestSuccessCallbackV3(config);
    // Get the active organization ID and add header if present
    const activeOrgId = getActiveOrgId();
    if (activeOrgId) {
        return Object.assign(Object.assign({}, baseConfig), { headers: Object.assign(Object.assign({}, baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.headers), { "X-Peek-Organization": activeOrgId }) });
    }
    return baseConfig;
};
// Add a request interceptor
baseDiscoverService.interceptors.request.use(requestSuccessCallbackDiscover, requestFailCallback);
// Discover-only response fail callback: surfaces the envelope's string error code and details
// (numeric error.cause.code stays unchanged for existing callers)
const responseFailCallbackDiscover = (error) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const body = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    const message = (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.error) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : error === null || error === void 0 ? void 0 : error.message) !== null && _d !== void 0 ? _d : "We are facing an issue. Please try again later.";
    const errorCode = (_e = body === null || body === void 0 ? void 0 : body.error) === null || _e === void 0 ? void 0 : _e.code;
    // Announced, not handled: the rejection means the active-organization mirror this request was
    // built from is stale, which no individual caller can fix. The error still rejects exactly as
    // before, so a caller with its own handling for the code keeps it.
    if (errorCode && ACTIVE_ORG_REJECTION_CODES.includes(errorCode)) {
        notifyActiveOrgRejected(errorCode);
    }
    return Promise.reject(new Error(message, {
        cause: {
            code: (_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.status, // numeric, unchanged for existing callers
            errorCode, // "active_org_required" | "wrong_organization" | ...
            details: (_g = body === null || body === void 0 ? void 0 : body.error) === null || _g === void 0 ? void 0 : _g.details, // { organizationId } on wrong_organization
            data: body === null || body === void 0 ? void 0 : body.payload,
        },
    }));
};
// Add a response interceptor
baseDiscoverService.interceptors.response.use(responseSuccessCallbackV3, responseFailCallbackDiscover);

export { baseDiscoverService as default, requestSuccessCallbackDiscover, responseFailCallbackDiscover };
